import AdditionalFilter from './AdditionalFilter/AdditionalFilter';
import ViewToggleButton from './ViewToggleButton/ViewToggleButton';
import YearsList from '../YearsList/YearsList';

import { useAdditionalFilterStore } from '../../stores/additionalFilterStore';

import { useMobileDetect } from '../../hooks/useMobileDetect';

import styles from './AdditionalMenu.module.less';

const AdditionalMenu = () => {
  const { isMobile } = useMobileDetect();
  const { isOpenFilterDropdown } = useAdditionalFilterStore();
  return (
    <div
      className={`${styles.additionalMenuContainer} ${!isOpenFilterDropdown && styles.additionalMenuContainerFixed}`}
    >
      <div className={styles.additionalMenu}>
        <AdditionalFilter />
        {isMobile ? <YearsList /> : <ViewToggleButton />}
      </div>
    </div>
  );
};

export default AdditionalMenu;
